<div class="navigation">
    <div class="navigation__back-to" [ngClass]="{'desktop-only': !showBackNav}" (click)="navigateBack()">
        <ng-container *ngIf="backText">
            <h4>Back to...</h4>
            <div class="horizontal-block">
                <span class="navigation__icon" alt="Back arrow"></span>
                <h5>{{backText}}</h5>
            </div>
        </ng-container>
    </div>
    <div class="navigation__continue-to" (click)="navigateForward()">

        <ng-container *ngIf="continueText">
            <h4>Continue to...</h4>
            <div class="horizontal-block">
                <h5>{{continueText}}</h5>
                <span class="navigation__icon"></span>
            </div>
        </ng-container>
    </div>
    <div class="mobile-hotspot mobile-only" (click)="mobileNavigation()"></div>
</div>